import { v4 as uuidv4 } from 'uuid';
import { sendCustomFullStoryEvent } from '../../../modules/vendor/fullstory/FullStoryUpdater';

// Only technical metadata is sent; never include preference values, payloads, or error messages.
export default function createStudyComOperation(operation) {
  let operationId;
  let startedAt;
  let page = 'other';
  try {
    operationId = uuidv4();
    startedAt = Date.now();
    const path = window.location.pathname;
    if (path.includes('/review/transition')) page = 'transition';
    else if (path.includes('/dashboard')) page = 'dashboard';
  } catch {
    return () => {};
  }

  return (step, details, result) => {
    try {
      const metadata = details || {};
      const config = result?.config || result?.response?.config;
      const headers = config?.headers;
      const requestId = headers?.['X-Request-Id'] || headers?.['x-request-id'];
      const httpStatus = result?.response?.status || result?.status;
      sendCustomFullStoryEvent('NAE_STUDY_COM_OPERATION', {
        operationId,
        operation,
        page,
        step,
        durationMs: Math.max(0, Date.now() - startedAt),
        ...(metadata.phase && { phase: metadata.phase }),
        ...(metadata.method && { method: metadata.method }),
        ...(metadata.attempt && { attempt: metadata.attempt }),
        ...(typeof requestId === 'string' && { requestId }),
        ...(typeof httpStatus === 'number' && { httpStatus }),
        ...(metadata.errorCode && { errorCode: metadata.errorCode }),
      });
    } catch { /* Tracking must never interrupt preference loading or saving. */ }
  };
}

export const studyComErrorCode = error => {
  if (['ECONNABORTED', 'ETIMEDOUT'].includes(error?.code)) return 'TIMEOUT';
  if (error?.response) return 'HTTP_ERROR';
  if (error?.message === 'Network Error' || error?.code === 'ERR_NETWORK') return 'NETWORK_ERROR';
  return 'REQUEST_FAILED';
};
